module.exports = __webpack_public_path__ + "static/media/star.5ed1feb9.svg";